<script>
import { Tabs, Tab, Field, Row, Col, Cell, Checkbox, Dialog } from 'vant'
import PickerSelector from '@/components/org/PickerSelector'
import TextSwitcher from '@/components/org/TextSwitcher'
import ImageViewer from '@/components/org/ImageViewer'
import MatchRule from '@/tbs/model/vo/MatchRule'
import { QNImageUtil } from '@/utils'

const matchRule = new MatchRule

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-rule-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-tabs': Tabs,
        'van-tab': Tab,
        'van-field': Field,
        'van-row': Row,
        'van-col': Col,
        'van-cell': Cell,
        'van-checkbox': Checkbox,
        'picker-selector': PickerSelector,
        'text-switcher': TextSwitcher,
        'image-viewer': ImageViewer,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                id: null,
                status: null,
                teamTotal: null,
                numSelection: null,
                type: null,
                specType: null,
                groupRoundNum: null,
                drawRankType: null,
                groupNum: null,
                groupNameType: null,
                eliminatedTeamNum: null,
                eliminatedRoundNum: null,
                roundTotal: null,
                periodTime: null,
                periodGapTime: null,
                pointType: null,
                substitutionType: null,
                restrictionNum: null,
                restrictionNumType: null,
                restrictionTimes: null,
                restrictionTimesType: null,
                isSubstitutionOn: null,
                isSubstitutionHalfCount: null,
                substitutionTotal: null,
                substitutionTotalType: null,
                substitutionOnceNum: null,
                isSpikeRequired: null,
                isSpikeAGRequired: null,
                isSpikeTFRequired: null,
                isSpikeMGRequired: null,
                isSpikeICRequired: null,
                isSpikeHGRequired: null,
                isSpikeFGRequired: null,
                isSpikeSGRequired: null,
                isLegGuardRequired: null,
                isMetalForbidden: null,
                dataMode: null,
            },
            game: {
                gameCount: 0
            },
            active: 0,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        numSelectionIndex() {
            return matchRule.numSelectionIndex
        },
        numSelectionOptions() {
            return matchRule.numSelectionOptions
        },
        matchTypeOptions() {
            return matchRule.matchTypeOptions
        },
        specTypeOptions() {
            return matchRule.getSpecTypeOptions(this.match.type)
        },
        /*groupNameTypeOptions() {
            return matchRule.groupNameTypeOptions
        },*/
        drawRankTypeOptions() {
            return matchRule.drawRankTypeOptions
        },
        isLeagureType() {
            return (this.match.type == '1')
        },
        isCupGroupType() {
            console.log('@isCupGroupType', this.match.specType)
            return (this.match.specType == '3' || this.match.specType == '4')
        },
        isNoGroupType() {
            return (this.match.specType == '5')
        },
        groupRoundNumField() {
            if (this.match.groupRoundNum) {
                return this.match.groupRoundNum
            }
            const groupRoundNum = matchRule.getGroupRoundNum(this.match.teamTotal, this.match.type, this.match.specType, this.match.groupNum)
            return isNaN(groupRoundNum) ? '' : groupRoundNum
        },
        groupRoundNumDesc() {
            const groupRoundNum = matchRule.getGroupRoundNum(this.match.teamTotal, this.match.type, this.match.specType, this.match.groupNum)
            const groupTeamNum = matchRule.getGroupTeamNum(this.match.matchType, this.match.specType, this.match.teamTotal, this.match.groupNum)
            if (!isNaN(groupRoundNum) && !isNaN(groupTeamNum) && this.match.groupNum) {
                return this.locale.localeProp('group-round-num-desc', {
                    group: this.match.groupNum,
                    team: groupTeamNum,
                    round: groupRoundNum
                })
            }
            else {
                return ''
            }
        },
        eliminatedRoundNumField() {
            const eliminatedRoundNum = matchRule.getEliminatedRoundNum(this.match.eliminatedTeamNum, this.match.teamTotal)
            return isNaN(eliminatedRoundNum) ? '' : eliminatedRoundNum
        },
        eliminatedRoundNumDesc() {
            const eliminatedRoundNum = matchRule.getEliminatedRoundNum(this.match.eliminatedTeamNum, this.match.teamTotal)
            if (!isNaN(eliminatedRoundNum)) {
                return this.locale.localeProp('eliminated-round-num-desc', {
                    round: eliminatedRoundNum
                })
            }
            else {
                return ''
            }
        },
        pointTypeOptions() {
            return matchRule.pointTypeOptions
        },
        substitutionTypeOptions() {
            return matchRule.substitutionTypeOptions
        },
        restrictionNumTypeOptions() {
            return matchRule.restrictionNumTypeOptions
        },
        restrictionTimesTypeOptions() {
            return matchRule.restrictionTimesTypeOptions
        },
        isRestrictionNumShow() {
            return (this.match.substitutionType == '1')
        },
        isRestrictionTimesShow() {
            return (this.match.substitutionType == '2')
        },
        isSubstitutionOnShow() {
            return (this.match.substitutionType == '1' 
                || this.match.substitutionType == '2' 
                || this.match.substitutionType == '4')
        },
        isSubstitutionHalfCountShow() {
            return (this.match.substitutionType == '2' || this.match.substitutionType == '4')
        },
        isSubstitutionOnceNumShow() {
            return (this.match.substitutionType == '4')
        },
        isSubstitutionTotalShow() {
            return (this.match.substitutionType == '4')
        },
        substitutionTotalTypeOptions() {
            return matchRule.substitutionTotalTypeOptions
        },
        dataModeOptions() {
            return matchRule.dataModeOptions
        },
        readonly() {
            console.log('readonly', this.match.status)
            return !(this.match.status === '1')
        },
        sampleImageUrl() {
            if (this.match.dataMode == '1') {
                return this.adjustImageSize(matchRule.getDataModeEventSampleUrl(), 450, 290)
            }
            else {
                return this.adjustImageSize(matchRule.getDataModeStatsSampleUrl(), 450, 290)
            }
        },
        samplePreviewImageUrl() {
            if (this.match.dataMode == '1') {
                return this.adjustImageSize(matchRule.getDataModeEventSampleUrl(), 900, 580)
            }
            else {
                return this.adjustImageSize(matchRule.getDataModeStatsSampleUrl(), 900, 580)
            }
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        match(value) {
            // console.log('@watch match', value)
            // save the initial team total as the first previous value
            this.prevTeamTotal = value.teamTotal
            this.prevGroupNum = value.groupNum
            this.prevEliminatedTeamNum = value.eliminatedTeamNum
            const self = this
            setTimeout(function() {
                self.ready = true
            }, 200)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onFieldInput(data) {
            console.log('onFieldInput', data)
            if (data != null) {
                this.submitData()
            }
        },
        onNumSelectionDataChange(data) {
            console.log('onNumSelectionDataChange', data)
            if (data.value == this.match.numSelection) {
                return
            }
            // confirm the change
            const self = this
            this.showConfirmDialog('change-number-selection', 'numSelection', data.value, null, function() {
                console.log('before submit')
                self.match.periodTime = matchRule.getPeriodTime(self.match.numSelection)
                self.match.periodGapTime = matchRule.getPeriodGapTime(self.match.numSelection)
            })
        },
        onTeamTotalFieldInput(data) {
            console.log('onTeamTotalFieldInput', data, this.match.teamTotal)
            if (!data || data == this.prevTeamTotal) {
                return
            }
            // confirm the change
            const self = this
            this.showConfirmDialog('change-team-total', 'teamTotal', this.prevTeamTotal, true, function() {
                console.log('before submit')
                console.log('# teamTotal', self.match.teamTotal)
                self.match.groupNum = matchRule.getGroupNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# groupNum', self.match.groupNum)
                self.match.groupRoundNum = matchRule.getGroupRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum)
                console.log('# groupRoundNum', self.match.groupRoundNum)
                self.match.eliminatedTeamNum = matchRule.getEliminatedTeamNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# eliminatedTeamNum', self.match.eliminatedTeamNum)
                self.match.eliminatedRoundNum = matchRule.getEliminatedRoundNum(self.match.eliminatedTeamNum, self.match.teamTotal)
                console.log('# eliminatedRoundNum', self.match.eliminatedRoundNum)
                self.match.roundTotal = matchRule.getTotalRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum, self.match.eliminatedTeamNum, self.match.eliminatedRoundNum)
                console.log('# roundTotal', self.match.roundTotal)
            })
            this.prevTeamTotal = data
        },
        onGroupNumFieldInput(data) {
            console.log('onGroupNumFieldInput', typeof(data),  data, !data)
            if (!data || data == this.prevGroupNum) {
                return
            }
            const self = this
            this.showConfirmDialog('change-group-num', 'groupNum', this.prevGroupNum, true, function() {
                console.log('# groupNum', self.match.groupNum)
                self.match.groupRoundNum = matchRule.getGroupRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum)
                console.log('# groupRoundNum', self.match.groupRoundNum)
                self.match.eliminatedTeamNum = matchRule.getEliminatedTeamNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# eliminatedTeamNum', self.match.eliminatedTeamNum)
                self.match.eliminatedRoundNum = matchRule.getEliminatedRoundNum(self.match.eliminatedTeamNum, self.match.teamTotal)
                console.log('# eliminatedRoundNum', self.match.eliminatedRoundNum)
                self.match.roundTotal = matchRule.getTotalRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum, self.match.eliminatedTeamNum, self.match.eliminatedRoundNum)
                console.log('# roundTotal', self.match.roundTotal)
            })
            this.prevGroupNum = data
        },
        onEliminatedTeamNumFieldInput(data) {
            console.log('onEliminatedTeamNumFieldInput', typeof(data),  data, !data, this.prevEliminatedTeamNum)
            if (!data || data == this.prevEliminatedTeamNum) {
                return
            }
            const self = this
            this.showConfirmDialog('change-eliminated-team-num', 'eliminatedTeamNum', this.prevEliminatedTeamNum, true, function() {
                console.log('into onEliminatedTeamNumFieldInput dialog confirm', self)
                console.log('# eliminatedTeamNum', self.match.eliminatedTeamNum)
                self.match.eliminatedRoundNum = matchRule.getEliminatedRoundNum(self.match.eliminatedTeamNum, self.match.teamTotal)
                console.log('# eliminatedRoundNum', self.match.eliminatedRoundNum)
                self.match.roundTotal = matchRule.getTotalRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum, self.match.eliminatedTeamNum, self.match.eliminatedRoundNum)
                console.log('# roundTotal', self.match.roundTotal)
            })
            this.prevEliminatedTeamNum = data
        },
        onTypeDataChange(data) {
            console.log('onTypeDataChange', data.value)
            if (data.value == this.match.type) {
                return
            }
            // confirm the change
            const self = this
            this.showConfirmDialog('change-type', 'type', data.value, null, function() {
                console.log('before submit')
                console.log('# type', self.match.type)
                self.match.specType = matchRule.getSpecType(self.match.type)
                console.log('# specType', self.match.specType)
                self.match.groupNum = matchRule.getGroupNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# groupNum', self.match.groupNum)
                self.match.groupRoundNum = matchRule.getGroupRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum)
                console.log('# groupRoundNum', self.match.groupRoundNum)
                self.match.eliminatedTeamNum = matchRule.getEliminatedTeamNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# eliminatedTeamNum', self.match.eliminatedTeamNum)
                self.match.eliminatedRoundNum = matchRule.getEliminatedRoundNum(self.match.eliminatedTeamNum, self.match.teamTotal)
                console.log('# eliminatedRoundNum', self.match.eliminatedRoundNum)
                self.match.roundTotal = matchRule.getTotalRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum, self.match.eliminatedTeamNum, self.match.eliminatedRoundNum)
                console.log('# roundTotal', self.match.roundTotal)
            })
        },
        onSpecTypeDataChange(data) {
            console.log('onSpecTypeDataChange', data.value, this.match.specType)
            if (data.value == this.match.specType) {
                return
            }
            // confirm the change
            const self = this
            this.showConfirmDialog('change-spec-type', 'specType', data.value, null, function() {
                console.log('before submit')
                console.log('# specType', self.match.specType)
                self.match.groupNum = matchRule.getGroupNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# groupNum', self.match.groupNum)
                self.match.groupRoundNum = matchRule.getGroupRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum)
                console.log('# groupRoundNum', self.match.groupRoundNum)
                self.match.eliminatedTeamNum = matchRule.getEliminatedTeamNum(self.match.type, self.match.specType, self.match.teamTotal)
                console.log('# eliminatedTeamNum', self.match.eliminatedTeamNum)
                self.match.eliminatedRoundNum = matchRule.getEliminatedRoundNum(self.match.eliminatedTeamNum, self.match.teamTotal)
                console.log('# eliminatedRoundNum', self.match.eliminatedRoundNum)
                self.match.roundTotal = matchRule.getTotalRoundNum(self.match.teamTotal, self.match.type, self.match.specType, self.match.groupNum, self.match.eliminatedTeamNum, self.match.eliminatedRoundNum)
                console.log('# roundTotal', self.match.roundTotal)
            })
        },
        onDrawRankTypeDataChange(data) {
            console.log('onDrawRankTypeDataChange', data)
            if (data.value == this.match.drawRankType) {
                return
            }
            this.match.drawRankType = data.value
            this.submitData()
        },
        /*onGroupNameTypeDataChange(data) {
            console.log('onGroupNameTypeDataChange', data)
            if (data.value == this.match.groupNameType) {
                return
            }
            this.match.groupNameType = data.value
            this.submitData()
        },*/
        onPointTypeDataChange(data) {
            console.log('onPointTypeDataChange', data)
            if (data.value == this.match.pointType) {
                return
            }
            this.match.pointType = data.value
            this.submitData()
        },
        onSubstitutionTypeDataChange(data) {
            console.log('onSubstitutionTypeDataChange', data.value)
            if (data.value == this.match.substitutionType) {
                return
            }
            this.match.substitutionType = data.value
            if (this.match.substitutionType == '1') {
                this.match.restrictionNumType = '1'
            }
            else if (this.match.substitutionType == '2') {
                this.match.restrictionTimesType = '1'
            }
            else if (this.match.substitutionType == '4') {
                this.match.substitutionTotalType = '1'
            }
            this.submitData()
        },
        onRestrictionNumTypeDataChange(data) {
            console.log('onRestrictionNumTypeDataChange', data)
            if (data.value == this.match.restrictionNumType) {
                return
            }
            this.match.restrictionNumType = data.value
            this.submitData()
        },
        onRestrictionFieldInput(data) {
            if (!data) {
                return
            }
            this.submitData()
        },
        onRestrictionTimesTypeDataChange(data) {
            console.log('onRestrictionTimesTypeDataChange', data)
            if (data.value == this.match.restrictionTimesType) {
                return
            }
            this.match.restrictionTimesType = data.value
            this.submitData()
        },
        onSubstitutionTotalTypeDataChange(data) {
            console.log('onSubstitutionTotalTypeDataChange', data)
            if (data.value == this.match.substitutionTotalType) {
                return
            }
            this.match.substitutionTotalType = data.value
            this.submitData()
        },
        onSubstitutionHalfCountDataChange(data) {
            if (data == this.match.isSubstitutionHalfCount) {
                return
            }
            this.match.isSubstitutionHalfCount = data
            this.submitData()
        },
        onSubstitutionOnDataChange(data) {
            if (data == this.match.isSubstitutionOn) {
                return
            }
            this.match.isSubstitutionOn = data
            this.submitData()
        },
        onSpikeRequiredDataChange(data) {
            if (data == this.match.isSpikeRequired) {
                return
            }
            this.match.isSpikeRequired = data
            this.submitData()
        },
        onSpecSpikeRequiredChange(data) {
            console.log('onSpecSpikeRequiredChange', data)
            this.submitData()
        },
        onLegGuardRequiredDataChange(data) {
            console.log('onLegGuardRequiredDataChange', data)
            if (data == this.match.isLegGuardRequired) {
                return
            }
            this.match.isLegGuardRequired = data
            this.submitData()
        },
        onMetalForbiddenDataChange(data) {
            console.log('onMetalForbiddenDataChange', data)
            if (data == this.match.isMetalForbidden) {
                return
            }
            this.match.isMetalForbidden = data
            this.submitData()
        },
        onDataModeDataChange(data) {
            console.log('onDataModeDataChange', data.value, this.game.gameCount)
            if (data.value == this.match.dataMode) {
                return
            }
            if (this.game.gameCount > 0) {
                // confirm the change
                this.showConfirmDialog('change-data-mode', 'dataMode', data.value)
            }
            else {
                this.match.dataMode = data.value
                this.submitData()
            }
        },
        onSaveBtnClick() {
            this.$emit('custom-event', {
                type: 'save',
                data: this.match
            })
        },
        getEliminatedRoundNum() {
            return Math.ceil(Math.sqrt(Number(this.match.eliminatedTeamNum)))
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        submitData() {
            console.log('submitData', this.ready)
            if (!this.ready) {
                return
            }
            this.$emit('custom-event', {
                type: 'submit',
                data: this.match
            })
        },
        showConfirmDialog(key, prop, value, reverse, beforeSubmit) {
            console.log('showConfirmDialog', key, prop, value, reverse, this.ignoreDialog)
            const self = this
            if (this.ignoreDialog) { 
                return
            }
            // confirm the change
            Dialog.confirm({
                title: this.locale[key],
                message: this.locale[key + '-confirm-message']
            }).then(() => {
                // on confirm
                // console.log('reverse', reverse)
                if (!reverse) {
                    console.log('set prop', prop, value)
                    this.match[prop] = value
                }
                // console.log('beforeSubmit', beforeSubmit ? true : false)
                this.ignoreDialog = true
                beforeSubmit && beforeSubmit()
                // delay to avoid the related confirm popup
                setTimeout(function() {
                    self.ignoreDialog = false
                }, 200)
                this.submitData()
            }).catch(() => {
                // on cancel
                if (!reverse) {
                    const originValue = this.match[prop]
                    this.match[prop] = value
                    // delay to restore the value in the next tick
                    setTimeout(function() {
                        self.match[prop] = originValue
                    }, 200)
                }
                else {
                    this.match[prop] = value
                }
            })
        },
    },
}
</script>

<template>
    <div class="match-rule-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <van-tabs 
            v-model="active" 
            scrollspy sticky
            offset-top="43"
        >
            <van-tab :title="locale['competition-format']">
                <picker-selector
                    :label="locale['match-num-selection-label']"
                    :options="numSelectionOptions"
                    :index="numSelectionIndex"
                    :value="match.numSelection"
                    :disabled="readonly"
                    @change-data="onNumSelectionDataChange"
                />
                <van-field
                    class="b-outer-margin"
                    v-model="match.teamTotal"
                    :label="locale['match-team-total-label']"
                    :placeholder="locale['match-team-total-placeholder']"
                    :disabled="readonly"
                    type="digit"
                    clearable
                    input-align="right"
                    maxlength="3"
                    @input="onTeamTotalFieldInput"
                />
                <picker-selector
                    :label="locale['match-type-label']"
                    :options="matchTypeOptions"
                    :value="match.type"
                    :disabled="readonly"
                    @change-data="onTypeDataChange"
                />
                <picker-selector
                    :label="locale['match-spec-type-label']"
                    :options="specTypeOptions"
                    :value="match.specType"
                    :disabled="readonly"
                    @change-data="onSpecTypeDataChange"
                />
                <van-field
                    v-if="isCupGroupType"
                    v-model="match.groupNum"
                    :label="locale['group-num-label']"
                    :disabled="readonly"
                    type="digit"
                    clearable
                    input-align="right"
                    maxlength="2"
                    @input="onGroupNumFieldInput"
                />
                <van-cell
                    v-if="isCupGroupType"
                    :class="{ disabled: readonly }"
                    :title="locale['group-round-num-label']"
                    :value="groupRoundNumField"
                    :label="groupRoundNumDesc"
                />
                <!--<picker-selector
                    v-if="isCupGroupType"
                    :label="locale['group-name-type-label']"
                    :options="groupNameTypeOptions"
                    :value="match.groupNameType"
                    :disabled="readonly"
                    @change-data="onGroupNameTypeDataChange"
                />-->
                <van-field
                    v-if="isCupGroupType"
                    v-model="match.eliminatedTeamNum"
                    :label="locale['eliminated-team-num-label']"
                    :disabled="readonly"
                    type="digit"
                    clearable
                    input-align="right"
                    maxlength="2"
                    @input="onEliminatedTeamNumFieldInput"
                />
                <van-cell
                    v-if="isCupGroupType"
                    :class="{ disabled: readonly }"
                    :title="locale['eliminated-round-num-label']"
                    :value="eliminatedRoundNumField"
                    :label="eliminatedRoundNumDesc"
                />
                <van-cell
                    :class="{ disabled: readonly }"
                    :title="locale['round-num-label']"
                    :value="match.roundTotal"
                />
                <picker-selector
                    v-if="!isNoGroupType"
                    :label="locale['draw-rank-type-label']"
                    :options="drawRankTypeOptions"
                    :value="match.drawRankType"
                    :disabled="readonly"
                    @change-data="onDrawRankTypeDataChange"
                />
                <van-row class="t-outer-margin b-outer-margin">
                    <van-col span="12">
                        <van-field
                            v-model="match.periodTime"
                            :label="locale['period-time-label']"
                            :placeholder="locale['period-time-placeholder']"
                            :disabled="readonly"
                            type="digit"
                            clearable center
                            input-align="right"
                            maxlength="3"
                            @input="onFieldInput"
                        />
                    </van-col>
                    <van-col span="12">
                        <van-field
                            v-model="match.periodGapTime"
                            :label="locale['period-gap-time-label']"
                            :placeholder="locale['period-gap-time-placeholder']"
                            :disabled="readonly"
                            type="digit"
                            clearable center
                            input-align="right"
                            maxlength="3"
                            @input="onFieldInput"
                        />
                    </van-col>
                </van-row>
                <picker-selector
                    class="b-outer-margin"
                    :label="locale['point-type-label']"
                    :options="pointTypeOptions"
                    :value="match.pointType"
                    :disabled="readonly"
                    @change-data="onPointTypeDataChange"
                />
                <picker-selector
                    :label="locale['substitution-type-label']"
                    :options="substitutionTypeOptions"
                    :value="match.substitutionType"
                    :disabled="readonly"
                    @change-data="onSubstitutionTypeDataChange"
                />
                <van-cell class="no-padding">
                    <van-row v-if="isRestrictionNumShow">
                        <van-col span="17">
                            <van-field
                                v-model="match.restrictionNum"
                                :label="locale['restriction-num-label']"
                                :placeholder="locale['restriction-num-placeholder']"
                                :disabled="readonly"
                                type="digit"
                                clearable 
                                input-align="right"
                                maxlength="2"
                                @input="onFieldInput"
                            />
                        </van-col>
                        <van-col span="7">
                            <picker-selector
                                :options="restrictionNumTypeOptions"
                                :value="match.restrictionNumType"
                                :disabled="readonly"
                                @change-data="onRestrictionNumTypeDataChange"
                            />
                        </van-col>
                    </van-row>
                </van-cell>
                <van-cell class="no-padding">
                    <van-row v-if="isRestrictionTimesShow">
                        <van-col span="17">
                            <van-field
                                v-model="match.restrictionTimes"
                                :label="locale['restriction-times-label']"
                                :placeholder="locale['restriction-times-placeholder']"
                                :disabled="readonly"
                                type="digit"
                                clearable 
                                input-align="right"
                                maxlength="2"
                                @input="onFieldInput"
                            />
                        </van-col>
                        <van-col span="7">
                            <picker-selector
                                :options="restrictionTimesTypeOptions"
                                :value="match.restrictionTimesType"
                                :disabled="readonly"
                                @change-data="onRestrictionTimesTypeDataChange"
                            />
                        </van-col>
                    </van-row>
                </van-cell>
                <van-cell class="no-padding">
                    <van-row v-if="isSubstitutionTotalShow">
                        <van-col span="17">
                            <van-field
                                v-model="match.substitutionTotal"
                                :label="locale['substitution-total-label']"
                                :placeholder="locale['substitution-total-placeholder']"
                                :disabled="readonly"
                                type="digit"
                                clearable 
                                input-align="right"
                                maxlength="2"
                                @input="onFieldInput"
                            />
                        </van-col>
                        <van-col span="7">
                            <picker-selector
                                :options="substitutionTotalTypeOptions"
                                :value="match.substitutionTotalType"
                                :disabled="readonly"
                                @change-data="onSubstitutionTotalTypeDataChange"
                            />
                        </van-col>
                    </van-row>
                </van-cell>
                <van-field
                    v-if="isSubstitutionOnceNumShow"
                    v-model="match.substitutionOnceNum"
                    :label="locale['substitution-once-num-label']"
                    :placeholder="locale['substitution-once-num-placeholder']"
                    :disabled="readonly"
                    type="digit"
                    clearable
                    input-align="right"
                    maxlength="2"
                    @input="onFieldInput"
                />
                <text-switcher 
                    v-show="isSubstitutionHalfCountShow"
                    :label="locale['is-substitution-half-count-label']"
                    :checked="match.isSubstitutionHalfCount"
                    :disabled="readonly"
                    @change-data="onSubstitutionHalfCountDataChange"
                />
                <text-switcher 
                    v-show="isSubstitutionOnShow"
                    :label="locale['is-substitution-on-label']"
                    :checked="match.isSubstitutionOn"
                    :disabled="readonly"
                    @change-data="onSubstitutionOnDataChange"
                />
            </van-tab>
            <van-tab :title="locale['other-rules']">
                <div class="u-outer-padding">
                    <span class="minor-text minor-color">{{ locale['other-rules-title'] }}</span>
                </div>
                <div class="spike-required-group b-outer-margin">
                    <text-switcher 
                        :label="locale['spike-required-label']"
                        :checked="match.isSpikeRequired"
                        :disabled="readonly"
                        @change-data="onSpikeRequiredDataChange"
                    />
                    <div 
                        v-if="match.isSpikeRequired"
                        class="bg-white u-outer-padding minor-text minor-color">
                        <van-checkbox 
                            class="b-inner-margin"
                            v-model="match.isSpikeAGRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-ag-required-label'] }}
                        </van-checkbox>
                        <van-checkbox 
                            class="b-inner-margin"
                            v-model="match.isSpikeTFRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-tf-required-label'] }}
                        </van-checkbox>
                        <van-checkbox 
                            class="b-inner-margin" 
                            v-model="match.isSpikeMGRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-mg-required-label'] }}
                        </van-checkbox>
                        <van-checkbox 
                            class="b-inner-margin" 
                            v-model="match.isSpikeICRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-ic-required-label'] }}
                        </van-checkbox>
                        <van-checkbox 
                            class="b-inner-margin"
                            v-model="match.isSpikeHGRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-hg-required-label'] }}
                        </van-checkbox>
                        <van-checkbox 
                            class="b-inner-margin"
                            v-model="match.isSpikeFGRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-fg-required-label'] }}
                        </van-checkbox>
                        <van-checkbox 
                            class="b-inner-margin" 
                            v-model="match.isSpikeSGRequired"
                            :disabled="readonly"
                            @change="onSpecSpikeRequiredChange">
                            {{ locale['spike-sg-required-label'] }}
                        </van-checkbox>
                    </div>
                </div>
                <text-switcher 
                    :label="locale['leg-guard-required-label']"
                    :checked="match.isLegGuardRequired"
                    :disabled="readonly"
                    @change-data="onLegGuardRequiredDataChange"
                />
                <text-switcher 
                    :label="locale['metal-forbidden-label']"
                    :checked="match.isMetalForbidden"
                    :disabled="readonly"
                    @change-data="onMetalForbiddenDataChange"
                />
            </van-tab>
            <van-tab :title="locale['data-display']">
                <div class="u-outer-padding">
                    <span class="minor-text minor-color">{{ locale['data-display-title'] }}</span>
                </div>
                <picker-selector
                    :label="locale['data-mode-label']"
                    :options="dataModeOptions"
                    :value="match.dataMode"
                    :disabled="readonly"
                    @change-data="onDataModeDataChange"
                />
                <image-viewer
                    :label="locale['data-mode-presentation-sample']"
                    :imageUrl="sampleImageUrl"
                    :previewImageUrl="samplePreviewImageUrl"
                    :imageWidth="225"
                    :imageHeight="145"
                />
            </van-tab>
        </van-tabs>
    </div>
</template>